var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHealthPoints = function SvgHealthPoints(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1419,
    height: 1416,
    viewBox: "-36 0 1419 1416"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1366 107q17 17 17 40.5t-17 40.5l-238 238h153v564H956v321H391v-150l-239 238q-17 17-41 17t-40-17l-90-89q-17-17-17-41t17-41l239-238H69V426h322V102h565v153l239-238q17-17 41-17t41 17z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M1366 107q17 17 17 40.5t-17 40.5L152 1399q-17 17-41 17t-40-17l-90-89q-17-17-17-41t17-41L1195 17q17-17 41-17t41 17z"
  })));
};
export default SvgHealthPoints;